/**
 * Dados estáticos do curso — Carregado localmente no frontend.
 * As imagens já estão em /public/capas/, nenhuma requisição de rede necessária.
 */

export const COURSE = {
  id: 'curso-fingerstyle-catolico',
  title: 'Curso de Fingerstyle Católico',
  description:
    'Aprenda a tocar músicas católicas em fingerstyle de maneira prática e organizada. Neste curso, você vai desenvolver técnica, entender como unir harmonia e melodia no violão e aprender arranjos que vão do nível básico ao avançado, além de descobrir como criar seus próprios fingerstyles.',
  image: '/capaEbooksLoja/capaCurso.png',
  originalPriceCents: 29700,
  priceSchedule: [
    { effectiveFrom: '2026-05-13', priceCents: 10700 }, // Lançamento: R$ 107,00
    { effectiveFrom: '2026-07-06', priceCents: 14700 }, // R$ 147,00
    { effectiveFrom: '2026-09-21', priceCents: 19700 }, // R$ 197,00
    { effectiveFrom: '2026-10-19', priceCents: 29700 }, // R$ 297,00 (preço cheio)
  ],
  modules: [
    {
      id: 'modulo-1',
      title: 'Módulo 1 — Apresentação e boas-vindas',
      freeAccess: true,
      lessons: [
        { id: 'm1-l1', title: 'Sejam bem-vindos!', durationSeconds: 186, youtubeId: 'M0xNplfTDgw', image: '/capas/1.png' },
        { id: 'm1-l2', title: 'Quem sou eu?', durationSeconds: 218, youtubeId: 'P0v6F206L7o', image: '/capas/2.png' },
        { id: 'm1-l3', title: 'O que é fingerstyle?', durationSeconds: 134, youtubeId: 'Zu8QjDxRvQ0', image: '/capas/3.png' },
        { id: 'm1-l4', title: 'Como vão funcionar nossas aulas?', durationSeconds: 249, youtubeId: 'p2Pk49Eu1JM', image: '/capas/4.png' },
      ],
    },
    {
      id: 'modulo-2',
      title: 'Módulo 2 — O básico que você precisa dominar',
      lessons: [
        { id: 'm2-l1', title: 'O que é harmonia e melodia?', durationSeconds: 240, youtubeId: 'L-TsFJReng8', image: '/capas/5.png' },
        { id: 'm2-l2', title: 'Qual a diferença entre harmonia e melodia?', durationSeconds: 210, youtubeId: 'FnrL9ulB0os', image: '/capas/6.png' },
        { id: 'm2-l3', title: 'A importância da harmonia para se tocar fingerstyle', durationSeconds: 180, youtubeId: 'c7PFE7J8Mrs', image: '/capas/7.png' },
        { id: 'm2-l4', title: 'Todas as músicas dão para tocar assim?', durationSeconds: 150, youtubeId: '_msmEfZchRw', image: '/capas/8.png' },
        { id: 'm2-l5', title: ' Sistema CAGED', durationSeconds: 300, youtubeId: 'qZJjRTdJHjQ', image: '/capas/47.png' },
        { id: 'm2-l6', title: 'Como ler tablatura?', durationSeconds: 300, youtubeId: 'tpZbVvB_en4', image: '/capas/9.png' },
      ],
    },
    {
      id: 'modulo-3',
      title: 'Módulo 3 — Técnica essencial do fingerstyle',
   lessons: [
        { id: 'm3-l1', title: 'Mão direita: a mais importante para se evoluir', durationSeconds: 360, youtubeId: 'ZGoVUPYYcO0', image: '/capas/10.png' },
        { id: 'm3-l2', title: 'Entendendo como funciona a mão esquerda', durationSeconds: 300, youtubeId: 'es53RXCAFqg', image: '/capas/11.png' },
        { id: 'm3-l3', title: 'O dedilhado mais importante de todos', durationSeconds: 270, youtubeId: 'Pd8PFJwwTrc', image: '/capas/12.png' },
        { id: 'm3-l4', title: 'Exercícios básicos de coordenação', durationSeconds: 420, youtubeId: 'ycCTXEEbjOo', image: '/capas/13.png' },
        { id: 'm3-l5', title: 'Dedilhado 2: o segundo mais usado', durationSeconds: 300, youtubeId: 'h_KtMjC3uNg', image: '/capas/37.png' },
        { id: 'm3-l6', title: 'Dedilhado 3: a terceira variação', durationSeconds: 300, youtubeId: 'CApe6i-yKJg', image: '/capas/38.png' },
      ],
    },
    {
      id: 'modulo-4',
      title: 'Módulo 4 — Músicas fáceis',
      lessons: [
        { id: 'm4-l1', title: 'Mãezinha do céu', durationSeconds: 360, youtubeId: 'xZaHJ6nDBSo', image: '/capas/14.png', freeAccess: true },
        { id: 'm4-l2', title: 'Maria de Nazaré', durationSeconds: 360, youtubeId: 'xFpVhS3K5So', image: '/capas/15.png', releaseDate: '2026-06-08' },
        { id: 'm4-l3', title: 'Pelos prados e campinas', durationSeconds: 360, youtubeId: 'C9lIcm0ISfY', image: '/capas/16.png', releaseDate: '2026-06-15' },
        { id: 'm4-l4', title: 'Povo de Deus foi assim', durationSeconds: 360, youtubeId: 'i5LcXva_8TM', image: '/capas/17.png', releaseDate: '2026-06-22' },
        { id: 'm4-l5', title: 'Sou bom pastor', durationSeconds: 360, youtubeId: 'Iuca5pMzAxc', image: '/capas/18.png', releaseDate: '2026-06-29' },
        { id: 'm4-l6', title: 'Vem, eu mostrarei', durationSeconds: 360, youtubeId: 'fpd2CzcNQe8', image: '/capas/19.png', releaseDate: '2026-07-06' }
      ],
    },
    {
      id: 'modulo-5',
      title: 'Módulo 5 — Músicas intermediárias',
      lessons: [
        { id: 'm5-l1', title: "A minh'alma abrirei", durationSeconds: 420, youtubeId: '7jcSmvB28jg', image: '/capas/20.png', releaseDate: '2026-07-06' },
        { id: 'm5-l2', title: 'A treze de maio', durationSeconds: 420, youtubeId: 'mXT0a9igRTw', image: '/capas/21.png', releaseDate: '2026-07-13' },
        { id: 'm5-l3', title: 'Cantar a beleza da vida', durationSeconds: 420, youtubeId: 'azsYPct3wzo', image: '/capas/22.png', releaseDate: '2026-07-20' },
        { id: 'm5-l4', title: 'Como a ovelha perdida', durationSeconds: 420, youtubeId: '019jWzyy9J0', image: '/capas/23.png', releaseDate: '2026-07-27' },
        { id: 'm5-l5', title: 'Como és lindo', durationSeconds: 420, youtubeId: '9JAPmIz3eoE', image: '/capas/24.png', releaseDate: '2026-08-03' },
        { id: 'm5-l6', title: 'Eu vim para que todos tenham vida', durationSeconds: 420, youtubeId: '-YDn0Jv0z7c', image: '/capas/25.png', releaseDate: '2026-08-10' },
        { id: 'm5-l7', title: 'Noite feliz', durationSeconds: 420, youtubeId: 'TODO_YT_ID', image: '/capas/26.png', releaseDate: '2026-08-17' },
        { id: 'm5-l8', title: 'Pelas estradas da vida', durationSeconds: 420, youtubeId: 'TODO_YT_ID', image: '/capas/27.png', releaseDate: '2026-08-24' },
        { id: 'm5-l9', title: 'Romaria', durationSeconds: 420, youtubeId: 'TODO_YT_ID', image: '/capas/28.png', releaseDate: '2026-08-31' },
        { id: 'm5-l10', title: 'Tão sublime sacramento', durationSeconds: 420, youtubeId: 'TODO_YT_ID', image: '/capas/29.png', releaseDate: '2026-09-07' },
      ],
    },
    {
      id: 'modulo-6',
      title: 'Módulo 6 — Músicas avançadas',
      lessons: [
        { id: 'm6-l1', title: 'Buscai primeiro', durationSeconds: 480, youtubeId: 'TODO_YT_ID', image: '/capas/30.png', releaseDate: '2026-09-14' },
        { id: 'm6-l2', title: 'Eu navegarei', durationSeconds: 480, youtubeId: 'TODO_YT_ID', image: '/capas/31.png', releaseDate: '2026-09-21' },
        { id: 'm6-l3', title: 'Prova de amor maior não há', durationSeconds: 480, youtubeId: 'TODO_YT_ID', image: '/capas/32.png', releaseDate: '2026-09-28' },
        { id: 'm6-l4', title: 'Vejam, eu andei pelas vilas', durationSeconds: 480, youtubeId: 'TODO_YT_ID', image: '/capas/33.png', releaseDate: '2026-10-05' },
      ],
    },
    {
      id: 'modulo-7',
      title: 'Módulo 7 — Aprenda você mesmo a tirar suas músicas',
      lessons: [
        { id: 'm7-l1', title: 'Como transformar uma música em fingerstyle', durationSeconds: 420, youtubeId: 'TODO_YT_ID', image: '/capas/34.png', releaseDate: '2026-10-12' },
        { id: 'm7-l2', title: 'Tirando melodias de ouvido', durationSeconds: 420, youtubeId: 'TODO_YT_ID', image: '/capas/35.png', releaseDate: '2026-10-19' },
        { id: 'm7-l3', title: 'Unindo harmonia com melodia', durationSeconds: 420, youtubeId: 'TODO_YT_ID', image: '/capas/36.png', releaseDate: '2026-10-26' },
      ],
    },
    {
      id: 'modulo-8',
      title: 'Módulo 8 — Ritmos e batidas',
      lessons: [
        { id: 'm8-l1', title: 'Dicas essenciais para se tocar qualquer ritmo', durationSeconds: 360, youtubeId: 'TODO_YT_ID', image: '/capas/55.jpg', releaseDate: '2026-11-02' },
        { id: 'm8-l2', title: 'Exercícios rítmicos para a mão direita', durationSeconds: 360, youtubeId: 'TODO_YT_ID', image: '/capas/56.jpg', releaseDate: '2026-11-09' },
        { id: 'm8-l3', title: 'Ritmo 1: o mais básico de todos', durationSeconds: 360, youtubeId: 'TODO_YT_ID', image: '/capas/57.jpg', releaseDate: '2026-11-16' },
        { id: 'm8-l4', title: 'Ritmo 2: o ritmo mais usado nas músicas católicas', durationSeconds: 360, youtubeId: 'TODO_YT_ID', image: '/capas/58.jpg', releaseDate: '2026-11-23' },
        { id: 'm8-l5', title: 'Ritmo 3: uma variação importante', durationSeconds: 360, youtubeId: 'TODO_YT_ID', image: '/capas/59.jpg', releaseDate: '2026-11-30' },
        { id: 'm8-l6', title: 'Aprendendo o ritmo das músicas', durationSeconds: 360, youtubeId: 'TODO_YT_ID', image: '/capas/61.jpg', releaseDate: '2026-12-07' },
        { id: 'm8-l7', title: 'Tocando os seus próprios ritmos', durationSeconds: 360, youtubeId: 'TODO_YT_ID', image: '/capas/62.jpg', releaseDate: '2026-12-14' },
      ],
    },
    {
      id: 'modulo-complementar',
      title: 'Módulo Complementar — Tirando músicas de ouvido',
      lessons: [
        { id: 'mc-l1', title: 'O que é campo harmônico', durationSeconds: 300, youtubeId: 'TODO_YT_ID', image: '/capas/40.png', releaseDate: '2026-11-02' },
        { id: 'mc-l2', title: 'Os acordes mais comuns que encontramos', durationSeconds: 300, youtubeId: 'TODO_YT_ID', image: '/capas/41.png', releaseDate: '2026-11-09' },
        { id: 'mc-l3', title: 'Campo harmônico MAIOR', durationSeconds: 300, youtubeId: 'TODO_YT_ID', image: '/capas/42.png', releaseDate: '2026-11-16' },
        { id: 'mc-l4', title: 'Campo harmônico de SOL', durationSeconds: 300, youtubeId: 'TODO_YT_ID', image: '/capas/43.png', releaseDate: '2026-11-23' },
        { id: 'mc-l5', title: 'Campo harmônico menor', durationSeconds: 300, youtubeId: 'TODO_YT_ID', image: '/capas/44.png', releaseDate: '2026-11-30' },
        { id: 'mc-l6', title: 'Campo harmônico de mi menor', durationSeconds: 300, youtubeId: 'TODO_YT_ID', image: '/capas/45.png', releaseDate: '2026-12-07' },
        { id: 'mc-l7', title: 'Como alterar a tonalidade das músicas', durationSeconds: 300, youtubeId: 'TODO_YT_ID', image: '/capas/46.png', releaseDate: '2026-12-14' },
      ],
    },
  ],
};

function todayIso(now = new Date()) {
  return now.toISOString().slice(0, 10);
}

/** Retorna o tier ativo (último cujo effectiveFrom <= hoje). */
export function currentPriceTier(now = new Date()) {
  const today = todayIso(now);
  const sorted = [...COURSE.priceSchedule].sort((a, b) =>
    a.effectiveFrom.localeCompare(b.effectiveFrom),
  );
  let active = sorted[0];
  for (const tier of sorted) {
    if (tier.effectiveFrom <= today) active = tier;
    else break;
  }
  return active;
}

/** Retorna os próximos reajustes (tiers futuros), em ordem cronológica. */
export function upcomingPriceTiers(now = new Date()) {
  const today = todayIso(now);
  return [...COURSE.priceSchedule]
    .filter((t) => t.effectiveFrom > today)
    .sort((a, b) => a.effectiveFrom.localeCompare(b.effectiveFrom));
}

/** Versão "pública" do curso — sem `youtubeId`. */
export function publicCourse() {
  const current = currentPriceTier();
  const upcoming = upcomingPriceTiers();
  return {
    id: COURSE.id,
    title: COURSE.title,
    description: COURSE.description,
    image: COURSE.image,
    priceCents: current.priceCents,
    originalPriceCents: COURSE.originalPriceCents,
    upcomingTiers: upcoming,
    totalLessons: COURSE.modules.reduce((sum, m) => sum + m.lessons.length, 0),
    modules: COURSE.modules.map((m) => ({
      id: m.id,
      title: m.title,
      freeAccess: Boolean(m.freeAccess),
      lessons: m.lessons.map((l) => ({
        id: l.id,
        title: l.title,
        durationSeconds: l.durationSeconds,
        image: l.image,
        releaseDate: l.releaseDate,
        freeAccess: Boolean(m.freeAccess) || Boolean(l.freeAccess),
      })),
    })),
  };
}

/** Procura uma aula pelo ID em qualquer módulo. */
export function findLesson(lessonId) {
  for (const module of COURSE.modules) {
    const lesson = module.lessons.find((l) => l.id === lessonId);
    if (lesson) return { module, lesson };
  }
  return null;
}
